import React from 'react';
import Modal from './Modal';
import find from 'lodash.find';
import { connect } from 'react-redux';

import {
  select,
  moveUp,
  moveDown,
  remove,
  save,
  changeColor,
  changeHoverColor,
  changeIconSize,
} from '../actions/social-media-element-actions';

import styles from '../../../../stylesheet/css/header-builder/social-media-element-options.css';

export const SocialMediaElementOptions = React.createClass({
  getInitialState() {
    return {
      iconInfoModalIsOpen: false,
      temporaryIconInfo: {}
    };
  },

  handleRemove(icon, e) {
    e.stopPropagation();
    this.props.onRemove(icon);
  },

  closeIconModal() {
    this.setState({
      ...this.state,
      iconInfoModalIsOpen: false
    });
  },

  handleSelect(icon) {
    this.props.onSelect(icon);
  },

  handleAdd() {
    this.setState({
      ...this.state,
      iconInfoModalIsOpen: true,
      temporaryIconInfo: {
        mode: 'add',
      }
    });
  },

  handleEdit(icon, e) {
    const { options = {} } = this.props,
          { icons = [] } = options;

    e.stopPropagation();

    this.setState({
      ...this.state,
      iconInfoModalIsOpen: true,
      temporaryIconInfo: {
        ...find(icons, i => i.className === icon),
        mode: 'edit',
        originalClassName: icon,
        classNameError: '',
      }
    });
  },

  handleModalCancelClick() {
    this.closeIconModal();
  },

  handleTemporaryIconInfoChange(key, value) {
    this.setState({
      ...this.state,
      temporaryIconInfo: {
        ...this.state.temporaryIconInfo,
        [key]: value
      }
    });
  },

  handleModalSaveClick() {
    const { id, className = '', url = '' } = this.state.temporaryIconInfo,
          classNameError = !className.trim() ? 'Icon class name is required!' : '';

    if (classNameError) {
      this.setState({
        ...this.state,
        temporaryIconInfo: {
          ...this.state.temporaryIconInfo,
          classNameError
        }
      });

      return;
    }

    this.props.onSave(this.state.temporaryIconInfo);
    this.closeIconModal();
  },

  renderIconList() {
    const {
      onSelect,
      onMoveUp,
      onMoveDown,
      onRemove,
      options = {}
    } = this.props;

    const { icons = [], selectedIcon } = options;
    let iconList;

    if (icons.length === 0) {
      iconList = (
        <span className={styles.empty}>
          Add icons using <span className="fa fa-plus"></span> button
        </span>
      );
    } else {
      iconList = (
        <div className={styles.iconList}>
          {
            icons.map(i => (
              <div
                key={i.className}
                className={styles.iconItem + (selectedIcon === i.className ? ' ' + styles.selected : '')}
                onClick={this.handleSelect.bind(null, i.className)}
              >
                <span
                  className={`${styles.iconItemEdit} fa fa-pencil-square-o`}
                  onClick={this.handleEdit.bind(null, i.className)}
                >
                </span>
                <span className={styles.iconItemText}>{i.className}</span>
                <span
                  className={`${styles.iconItemRemove} fa fa-remove`}
                  onClick={this.handleRemove.bind(null, i.className)}
                >
                </span>
              </div>
            ))
          }
        </div>
      );
    }

    return (
      <div>
        {iconList}
        <div className={styles.iconListFooter}>
          <span className={`${styles.add} fa fa-plus fa-lg`} onClick={this.handleAdd}></span>
          <span className={`${styles.moveDown} fa fa-chevron-down fa-lg`} onClick={onMoveDown}></span>
          <span className={`${styles.moveUp} fa fa-chevron-up fa-lg`} onClick={onMoveUp}></span>
        </div>
      </div>
    );
  },

  renderModal() {
    return (
      <Modal
        isOpen={this.state.iconInfoModalIsOpen}
        contentLabel='Social Media Element Options'
        header={
          this.state.temporaryIconInfo.mode === 'edit'
            ? `Edit ${this.state.temporaryIconInfo.originalClassName} icon`
            : 'Add new icon'
        }
        footer={[
          {
            text: this.state.temporaryIconInfo.mode === 'edit' ? 'Save' : 'Add',
            onClick: this.handleModalSaveClick
          },
          { text: 'Cancel', onClick: this.handleModalCancelClick }
        ]}
        width='400px'
      >
        <header>Class Name (required)</header>
        <select autoFocus="true" value={this.state.temporaryIconInfo.className || ''} onChange={e => this.handleTemporaryIconInfoChange('className', e.target.value)}>
            <option value="px">px</option>
            <option value="aim">aim</option>
            <option value="amazon">amazon</option>
            <option value="apple">apple</option>
            <option value="bebo">bebo</option>
            <option value="behance">behance</option>
            <option value="blogger">blogger</option>
            <option value="delicious">delicious</option>
            <option value="deviantart">deviantart</option>
            <option value="digg">digg</option>
            <option value="dribbble">dribbble</option>
            <option value="dropbox">dropbox</option>
            <option value="envato">envato</option>
            <option value="facebook">facebook</option>
            <option value="flickr">flickr</option>
            <option value="github">github</option>
            <option value="google">google</option>
            <option value="googleplus">googleplus</option>
            <option value="lastfm">lastfm</option>
            <option value="linkedin">linkedin</option>
            <option value="instagram">instagram</option>
            <option value="myspace">myspace</option>
            <option value="path">path</option>
            <option value="pinterest">pinterest</option>
            <option value="reddit">reddit</option>
            <option value="rss">rss</option>
            <option value="skype">skype</option>
            <option value="stumbleupon">stumbleupon</option>
            <option value="tumblr">tumblr</option>
            <option value="twitter">twitter</option>
            <option value="vimeo">vimeo</option>
            <option value="wordpress">wordpress</option>
            <option value="yahoo">yahoo</option>
            <option value="yelp">yelp</option>
            <option value="youtube">youtube</option>
            <option value="xing">xing</option>
            <option value="imdb">imdb</option>
            <option value="qzone">qzone</option>
            <option value="renren">renren</option>
            <option value="vk">vk</option>
            <option value="wechat">wechat</option>
            <option value="weibo">weibo</option>
            <option value="whatsapp">whatsapp</option>
            <option value="soundcloud">soundcloud</option>
        </select>
        <br />
        <br />
        <header>URL</header>
        <input
          type="text"
          value={this.state.temporaryIconInfo.url || ''}
          onChange={e => this.handleTemporaryIconInfoChange('url', e.target.value)}
        />
      </Modal>
    );
  },

  render() {
    const {
      onChangeColor,
      onChangeHoverColor,
      onChangeIconSize,
      options = {},
    } = this.props;

    const { color, hoverColor, iconSize, sizes } = options;

    return (
      <div>
        <header>Icons:</header>
        {this.renderIconList()}

        <header>Color:</header>
        <input
          type="color"
          value={color}
          onChange={e => onChangeColor(e.target.value)} />

        <header>Hover Color:</header>
        <input
          type="color"
          value={hoverColor}
          onChange={e => onChangeHoverColor(e.target.value)} />

        <header>Size:</header>
        <select
          value={iconSize}
          onChange={e => onChangeIconSize(e.target.value)}>
          {sizes.map(s => <option key={s.value} value={s.value}>{s.text}</option>)}
        </select>
        <label>&nbsp;px</label>

        {this.renderModal()}
      </div>
    );
  }
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id, options } = ownProps,
        selectedIcon = options.selectedIcon;

  return {
    onSelect(icon) {
      dispatch(select({ device, id, icon }));
    },

    onMoveUp() {
      dispatch(moveUp({ device, id, selectedIcon }));
    },

    onMoveDown() {
      dispatch(moveDown({ device, id, selectedIcon }));
    },

    onRemove(icon) {
      dispatch(remove({ device, id, icon }));
    },

    onSave(iconInfo) {
      dispatch(save({ device, id, iconInfo }));
    },

    onChangeColor(color) {
      dispatch(changeColor({ device, id, color }));
    },

    onChangeHoverColor(hoverColor) {
      dispatch(changeHoverColor({ device, id, hoverColor }));
    },

    onChangeIconSize(iconSize) {
      dispatch(changeIconSize({ device, id, iconSize }));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(SocialMediaElementOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/SocialMediaElementOptions.js